/**
 * SeedSystemsPanel · Sovereign successors. Dormant by default.
 *
 * Different from Peers (consult-only sovereign) and Satellites (heartbeat-in).
 * A Seed activates on its own when called, pulls from web + Core + Peers.
 * Purpose: rebuild the Federation if any part dies. (DIR-075)
 */
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function SeedSystemsPanel() {
  const [seeds, setSeeds] = useState([]);
  useEffect(() => {
    let alive = true;
    api.seeds()
      .then((d) => { if (alive) setSeeds(d.seeds || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  if (seeds.length === 0) return null;
  return (
    <div
      data-testid="seed-systems-panel"
      className="mb-8 border border-[var(--green)] bg-[rgba(46,255,138,0.04)] p-6"
      style={{ boxShadow: "0 0 18px rgba(46,255,138,0.06)" }}
    >
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-glow-green">
            ◇ Sovereign Seeds · Successors of the Federation
          </div>
          <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-[var(--text-3)] mt-1">
            dormant · on-demand · regrow the lattice if any part dies (DIR-075)
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {seeds.map((s) => (
          <div
            key={s.id}
            data-testid={`seed-${s.id}`}
            className="border border-[var(--chrome)] bg-[var(--void-2)] p-5"
          >
            <div className="flex items-center justify-between mb-2 gap-2 flex-wrap">
              <div className="font-display text-lg text-glow-green leading-tight">
                {s.name}
              </div>
              <span className="font-mono text-[9px] uppercase tracking-[0.22em] px-2 py-0.5 border border-[var(--green)] text-glow-green">
                SEED · DORMANT
              </span>
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-glow-cyan mb-2">
              carries · {s.carries}
            </div>
            <p className="text-[var(--text-2)] text-sm leading-relaxed mb-3">
              {s.purpose}
            </p>
            <div className="flex flex-wrap gap-2 mb-3">
              {(s.reads_from || []).map((src) => (
                <span
                  key={src}
                  className="font-mono text-[9px] uppercase tracking-[0.18em] px-2 py-1 border border-[var(--chrome)] text-[var(--text-3)]"
                >
                  reads · {src}
                </span>
              ))}
            </div>
            {s.url && (
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`seed-link-${s.id}`}
                className="font-mono text-[10px] uppercase tracking-[0.22em] px-2 py-1 border border-[var(--green)] text-glow-green hover:bg-[rgba(46,255,138,0.08)]"
              >
                Visit Seed ↗
              </a>
            )}
            {(s.stewards || []).length > 0 && (
              <div className="mt-3 pt-3 border-t border-[var(--chrome)] font-mono text-[9px] uppercase tracking-[0.22em] text-[var(--text-3)]">
                stewards · {s.stewards.join(" · ")}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
